// The public site plays on the stage theme (css/_variables.css). The admin leaves it off and keeps its own look.
export function useStageTheme () {
  useHead({ htmlAttrs: { 'data-theme': 'stage' } })
}
